const STORAGE_KEY = "mail_attachment_flags_v1";
const MAX_ENTRIES = 96;

type AttachmentFlagsEntry = {
  accountId: number;
  folder: string;
  flags: Record<number, boolean>;
  savedAt: number;
};

function readAll(): AttachmentFlagsEntry[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as AttachmentFlagsEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(entries: AttachmentFlagsEntry[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
  } catch {
    /* quota */
  }
}

export function readAttachmentFlagsCache(
  accountId: number,
  folder: string
): Map<number, boolean> {
  const entry = readAll().find(
    (e) => e.accountId === accountId && e.folder === folder
  );
  const map = new Map<number, boolean>();
  if (!entry?.flags) return map;

  for (const [uidRaw, value] of Object.entries(entry.flags)) {
    const uid = Number(uidRaw);
    if (uid > 0) {
      map.set(uid, value === true);
    }
  }
  return map;
}

export function mergeAttachmentFlagsCache(
  accountId: number,
  folder: string,
  flags: Map<number, boolean>
): void {
  if (flags.size === 0) return;

  const rest = readAll().filter(
    (e) => !(e.accountId === accountId && e.folder === folder)
  );
  const existing = readAll().find(
    (e) => e.accountId === accountId && e.folder === folder
  );

  const merged: Record<number, boolean> = { ...(existing?.flags ?? {}) };
  for (const [uid, value] of flags) {
    if (uid > 0) {
      merged[uid] = value;
    }
  }

  const next: AttachmentFlagsEntry = {
    accountId,
    folder,
    flags: merged,
    savedAt: Date.now(),
  };

  writeAll([next, ...rest]);
}

export function clearAttachmentFlagsCacheForAccount(accountId: number): void {
  writeAll(readAll().filter((e) => e.accountId !== accountId));
}

export function clearAllAttachmentFlagsCache(): void {
  writeAll([]);
}
